import { ResponseFinancialDataManagerCreate, RequestFinancialDataManagerCreate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { FinancialDataManagerCreateActions } from '../actions';
import { FinancialDataManagerCreateTypes } from '../../shared/enums';

export interface FinancialDataManagerCreateState {
    response: ResponseFinancialDataManagerCreate;
    request: RequestFinancialDataManagerCreate;
    error: any;
}

export const FinancialDataManagerCreateInitialState: FinancialDataManagerCreateState = {
    response: null,
    request: null,
    error: null
};

const _financialDataManagerCreateReducer = createReducer(
    FinancialDataManagerCreateInitialState,

    on(FinancialDataManagerCreateActions.getFinancialDataManagerCreate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(FinancialDataManagerCreateActions.getFinancialDataManagerCreateSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(FinancialDataManagerCreateActions.getFinancialDataManagerCreateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(FinancialDataManagerCreateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function financialDataManagerCreateReducer(state, action) {
    if (action.type === FinancialDataManagerCreateTypes.FINANCIAL_DATA_MANAGER_CREATE) {
        state = undefined;
    }
    return _financialDataManagerCreateReducer(state, action);
}
